import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleG1Service {

  constructor(private http: HttpClient) { }

  saveScheduleG1(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalParams: any = {},
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=vlm7h1`;
    
    // Build AngularJS-compatible payload structure
    // filterParams already contains scenarioCode and is_issue_key_enabled (set in AngularJS controller)
    let params: any = _.merge({}, globalParams, filterParams);
    
    // Build checkLockedbj from rowData (required by backend)
    const checkLockedbj = [{
      leid: rowData.LEID || rowData.leid || '',
      cdr_number: rowData.CDR_NO || rowData.cdr_number || '',
      reporting_period: rowData.REPORTING_PERIOD || rowData.reporting_period || 1,
      combination_key: rowData.HO_COMBINATION_KEY || rowData.COMBINATION_KEY || rowData.combination_key,
      scenario_key: filterParams.scenario || globalParams.scenario
    }];
    
    // Add required data
    params = _.extend({
      jsonObj: JSON.stringify(scheduleDetails),
      jsonSettings: JSON.stringify(scheduleSettings),
      process_name: "Form_5471_Schedule_G1_Save",
      checkLockedbj: JSON.stringify(checkLockedbj)
    }, params);
    
    // Use HttpParams for application/x-www-form-urlencoded (matching AngularJS $http behavior)
    let body = new HttpParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        body = body.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    const options = {
      headers: headers,
      withCredentials: true
    };
    
    return this.http.post<any>(url, body.toString(), options);
  }
}



